function redactSensitiveInfo(s) {
    return s.replace(
    // remove email
    /[^\s@]+@[^\s@]+\.[^\s@]+/g, '***').replace(
    // remove phoneNumber
    // must start with a number
    /([0-9]|six|Six|SIX|eight|Eight|EIGHT|nine|Nine|NINE)([0-9 _-]+|(one|One|ONE|two|Two|TWO|three|Three|THREE|four|Four|FOUR|five|Five|FIVE|six|Six|SIX|seven|Seven|SEVEN|eight|Eight|EIGHT|nine|Nine|NINE|zero|Zero|ZERO)){7,24}/g, '***');
}
export { redactSensitiveInfo };
